import { DefaultState } from '@src/redux/types'

import { ANALYTICS_ADMISSION_OFFICE } from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [ANALYTICS_ADMISSION_OFFICE]: DefaultState<`${typeof API.ANALYTICS_ADMISSION_OFFICE}`, 'get'>
} = () => ({
  [ANALYTICS_ADMISSION_OFFICE]: defaultState(),
})
